import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { TFunction } from 'i18next';

type OpenSkipConfirmModalParams = {
  count: number;
  isPending: boolean;
  onConfirm: () => void | Promise<void>;
  t: TFunction;
};

export function openSkipConfirmModal({
  count,
  isPending,
  onConfirm,
  t,
}: OpenSkipConfirmModalParams) {
  modals.openConfirmModal({
    title: t('farmer-validation.skip-confirm-title'),
    children: (
      <Text size="sm" style={{ lineHeight: 1.6 }}>
        {t('farmer-validation.skip-confirm-body', { count })}
      </Text>
    ),
    labels: {
      confirm: t('farmer-validation.skip-confirm-confirm'),
      cancel: t('common.cancel'),
    },
    confirmProps: { loading: isPending },
    onConfirm,
  });
}
